import genererGuid from '@/services/general/genererGuid';

export default function genererEncart(surfaceId, emplacementId, couleurEncartId, largeur, hauteur) {
  return {
    id: genererGuid(),
    reference: null,
    libelle: null,
    surfaceId: surfaceId || null,
    emplacementId: emplacementId || null,
    couleurEncartId: couleurEncartId || null,
    formatPresseId: null,
    largeur: largeur || null,
    hauteur: hauteur || null,
    dateDebut: null,
    dateFin: null,
    quantite: 1,
    prixUnitaire: null,
    actif: true,
    selected: false,
    isCreate: true,
    categorieOperation: null,
    libelleComplementaire: '',
    tauxTva: 20,
  };
}
